
import validator from 'validator';

import moment from 'moment'
import 'moment/locale/tr'  // without this line it didn't work
moment.locale('tr');

function emailIsValid(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
    return re.test(String(email).toLowerCase());
}

function returnState(state, strings, key) {
    return strings[key]['state'][state]
}

const getSortedProducts = (products, sortType, sortValue) => {
    if (products && sortType && sortValue) {
        if (sortType === "category") {
            return products.filter(
                product => product.product.category.filter(single => single.id === sortValue)[0]
            );
        }

        if (sortType === "color") {
            return products.filter(product => product.color.id === sortValue)
        }

        if (sortType === "filterSort") {
            let sortProducts = [...products];
            if (sortValue === "default") {
                return sortProducts;
            }
            if (sortValue === "priceHighToLow") {
                return sortProducts.sort((a, b) => {
                    return b.product.normalPrice.try - a.product.normalPrice.try;
                });
            }
            if (sortValue === "priceLowToHigh") {
                return sortProducts.sort((a, b) => {
                    return a.product.normalPrice.try - b.product.normalPrice.try;
                });
            }
        }
    }
    return products;
};

// get individual element
const getIndividualItemArray = array => {
    let individualItemArray = array.filter(function (v, i, self) {
        return i === self.findIndex(obj => String(obj.id) === String(v.id));
    });
    return individualItemArray;
};

// get individual categories
export const getIndividualCategories = products => {
    let productCategories = [];
    products &&
        products.map(product => {
            return (
                product.product.category &&
                product.product.category.map(single => {
                    return productCategories.push(single);
                })
            );
        });
    const individualProductCategories = getIndividualItemArray(productCategories);
    return individualProductCategories;
};


// get individual colors
export const getIndividualColors = products => {
    let productColors = [];
    products &&
        products.map(single => {
            return productColors.push(single.color);
        });
    const individualProductColors = getIndividualItemArray(productColors);
    return individualProductColors;
};

export const getIndividualProducts = products => {
    let productsData = [];
    products &&
        products.map(single => {
            return productsData.push(single.product);
        });
    const individualProducts = getIndividualItemArray(productsData);
    return individualProducts;
};

// get individual sizes
export const getProductsIndividualSizes = products => {
    let productSizes = [];
    products &&
        products.map(product => {
            return (
                product.variation &&
                product.variation.map(single => {
                    return single.size.map(single => {
                        return productSizes.push(single.name);
                    });
                })
            );
        });
    const individualProductSizes = getIndividualItemArray(productSizes);
    return individualProductSizes;
};

// get product individual sizes
export const getIndividualSizes = product => {
    let productSizes = [];
    product.variation &&
        product.variation.map(singleVariation => {
            return (
                singleVariation.size &&
                singleVariation.size.map(singleSize => {
                    return productSizes.push(singleSize.name);
                })
            );
        });
    const individualSizes = getIndividualItemArray(productSizes);
    return individualSizes;
};

export const setActiveSort = e => {
    const filterButtons = document.querySelectorAll(
        ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
    );
    filterButtons.forEach(item => {
        item.classList.remove("active");
    });
    e.currentTarget.classList.add("active");
};

export const setActiveLayout = e => {
    const gridSwitchBtn = document.querySelectorAll(".shop-tab button");
    gridSwitchBtn.forEach(item => {
        item.classList.remove("active");
    });
    e.currentTarget.classList.add("active");
};

export const toggleShopTopFilter = e => {
    const shopTopFilterWrapper = document.querySelector(
        "#product-filter-wrapper"
    );
    shopTopFilterWrapper.classList.toggle("active");
    if (shopTopFilterWrapper.style.height) {
        shopTopFilterWrapper.style.height = null;
    } else {
        shopTopFilterWrapper.style.height =
            shopTopFilterWrapper.scrollHeight + "px";
    }
    e.currentTarget.classList.toggle("active");
};


const checkFormFields = (data, checkContent, strings) => {

    var nullFields = [];
    var invalidFields = [];

    for (let item of data) {
        if (item.required) {
            switch (item.type) {
                case "bool":
                    if (item.value === false) {
                        nullFields.push(item);
                    }
                    break;
                default:
                    if (item.value.length === 0) {
                        item["helperText"] = strings['alerts']['empty'];
                        nullFields.push(item);
                    } else {
                        if (checkContent === true) {
                            if (item.type === "number") {
                                if (item.value <= 0) {
                                    item["helperText"] = "Lütfen 0 dan büyük bir değer giriniz";
                                    invalidFields.push(item);
                                }
                            }
                            switch (item.key.trim()) {
                                case "email":
                                case "email_forgot":
                                    if (!emailIsValid(item.value)) {
                                        item["helperText"] = strings['alerts']['invalidEmail'];
                                        invalidFields.push(item);
                                    }
                                    break;
                                case "tcNumber":
                                    if (!validator.isNumeric(item.value) || item.value.length !== 11) {
                                        item["helperText"] = "Lütfen geçerli bir Tc kimlik no giriniz";
                                        invalidFields.push(item);
                                    }
                                    break;
                                case "mobilePhone":
                                    if (!validator.isMobilePhone(item.value, "tr-TR")) {
                                        item["helperText"] = "Lütfen geçerli bir telefon numarası giriniz";
                                        invalidFields.push(item);
                                    }
                                    break;

                                default:
                                    break;

                            }
                        }
                    }
                    break;
            }
        }
    }

    return {
        result: nullFields.length > 0 || invalidFields.length > 0 ? true : false,
        nullFields: nullFields,
        invalidFields: invalidFields
    };
}


export {
    checkFormFields,
    emailIsValid,
    getSortedProducts,
    moment,
    validator,
    returnState
}